import CareerPostPurchaseSessions from './CareerPostPurchaseSessions'
export default CareerPostPurchaseSessions
